<template>
  <div>
    <el-dialog :visible.sync="visible" width="66%">
      <div slot="title" class="title-container">
        <span>{{product.name}}</span>
        <div class="prices-container">
          <span>Standard:&nbsp;{{product.standardPrice}}</span>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span>Mth Special:&nbsp;{{product.specialPrice}}</span>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span>Cls A /COD:&nbsp;{{product.classAPrice}}</span>
          <span>&nbsp;&nbsp;|&nbsp;&nbsp;</span>
          <span>Cls B /Spcl:&nbsp;{{product.classBPrice}}</span>
        </div>
      </div>
      <el-form label-width="260px">
        <el-row>
          <el-col :span="8" v-for="p in prices" :key="p.id">
            <el-form-item :label="p.name">
              <el-input
                type="number"
                v-model="p.price"
                :step="0.01"
                :min="0"
                size="mini"
                style="width: 120px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogFormVisible">Cancel</el-button>
        <el-button size="mini" type="primary" @click="handleSubmit">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { modifyDetail } from '../api'
export default {
  name: 'DialogOcopEdit',
  computed: {
    visible: {
      get () {
        return this.dialogVisible
      },
      set (val) {
        this.$emit('closed')
      }
    }
  },
  data () {
    return {
      prices: []
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      required: true
    },
    ocop: {
      type: Array,
      required: true
    }
  },
  methods: {
    dialogFormVisible () {
      this.$emit('closed')
    },
    async handleSubmit () {
      const params = this.prices.map(p => {
        return { id: p.id, price: p.price }
      })
      // console.log(params)
      await modifyDetail(this.product.id, { prices: params })

      this.$message({
        message: 'Operation successful',
        type: 'success'
      })
      // this.reload(this.id)
      this.$emit('success')
    }
  },
  watch: {
    ocop: function (val) {
      this.prices = val
    }
  }
}
</script>

<style lang="scss" scoped>
.title-container {
  color: #000;
  line-height: 48px;
  padding: 0 60px 0 20px;
  font-size: 13px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
}
</style>
